interface FirebaseConfig {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}

interface Config {
  affiliatePolicyVersion: string
  calendarRecurringEventsEnabled: string[]
  companyIdForManagingTemplates: string
  defaultReviewSMS: string
  depreciatedFeatureDate: string
  fcmPublicKey: string
  fcmSenderId: string
  firebase: FirebaseConfig
  funnelShare: string
  gdprSignDocument: string
  genericElizaId: string
  googleAnalyticId?: string
  googleAuthId: string
  googleMapsAPIKey: string
  hipaaComplianceServiceId: string
  internalAgencyForLevelUp: string[]
  locationIdForTemplateLibrary: string
  mode: string
  newCalendarSettingsEnabled: string[]
  printfulMarketplaceAppId: string
  privacyPolicyVersion: string
  seasonOfAIEnabledAgency: string[]
  serverIPAddress: string
  shippoMarketplaceAppId: string
  shipstationMarketplaceAppId: string
  stripeKey: string
  termsOfServiceThrottle: number
  tosVersion: string
  whatsappMetaAppId: number
  whatsappMetaAppVersion: string
  whitelabelIPAddress: string
  workflowServiceURL: string
  freshchat: {
    token: string
    host: string
    widgetUuid?: string
    successWidgetUUID?: string
  }
  agentStudioAgencyIds: string[]
  agentStudioSubAccountIds: string[]
}

const override: Boolean = process?.env?.VUE_APP_DB_OVERRIDE === 'true'

const config: { [key: string]: Config } = {
  development: {
    affiliatePolicyVersion: '03/02/2021',
    calendarRecurringEventsEnabled: ['5DP4iH6HLkQsiKESj6rh', 'z15tg6TRo3BPFPhquVuz'],
    companyIdForManagingTemplates: 'eejDKnO8OMdu5q4F7rMB',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    depreciatedFeatureDate: '2021-09-21',
    fcmPublicKey: override
      ? 'BAVB9sZxhteplpxkSQXvCF57NEXzFZbC3aO6sFxQGH5vujYLN12R6HxD52REe_xMotrXqAIeroKrQlAAgJH3hMc'
      : 'BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4',
    fcmSenderId: override ? '439472444885' : '439472444885',
    firebase: override
      ? {
          apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
          authDomain: 'highlevel-backend.firebaseapp.com',
          databaseURL: 'https://highlevel-backend.firebaseio.com',
          projectId: 'highlevel-backend',
          storageBucket: 'highlevel-backend.appspot.com',
          messagingSenderId: '439472444885',
          appId: '1:439472444885:android:c48022009a58ffc7',
        }
      : {
          apiKey: 'AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo',
          authDomain: 'highlevel-staging.firebaseapp.com',
          databaseURL: 'https://highlevel-staging.firebaseio.com',
          projectId: 'highlevel-staging',
          storageBucket: 'highlevel-staging.appspot.com',
          messagingSenderId: '85350210461',
          appId: '1:85350210461:web:d3728d34bf8bd6b5',
        },
    funnelShare: 'http://localhost:8080/funnels/share',
    gdprSignDocument: 'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    genericElizaId: 'events-search-enhv',
    googleAuthId: '85350210461-eu3b772ek6gqmlpeim86m62ab9i9u5pc.apps.googleusercontent.com',
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    hipaaComplianceServiceId: 'tecJjL67Ol5kwLItrBwe',
    internalAgencyForLevelUp: ['YuTUZlUtrwBtvmgByZDW', '5DP4iH6HLkQsiKESj6rh', 'aM2Z760DXgoa6AIEZx8N'],
    locationIdForTemplateLibrary: 'f8xXtCLtJndXyDchiomd',
    mode: 'dev',
    newCalendarSettingsEnabled: ['5DP4iH6HLkQsiKESj6rh'],
    printfulMarketplaceAppId: '660521e9a3fdabb92ce522a8',
    privacyPolicyVersion: '19/08/2024',
    seasonOfAIEnabledAgency: [
      '5DP4iH6HLkQsiKESj6rh',
      'KxPPrN1TUQdti5UBmPxR',
      '0iYoWYlmHoUBP2ZW6R7P',
      '8BSZPFT2PdzbeF4rIGX3',
      'zycCcd3QGdr5dZ739G6b', //trial
      '10nCS4icS5y5G5j5lCTB', //297
      '2DqbmJKMiiOAveUdzs12', //297
      '3x5QvX4vaasaecjwCKEP',
      'Su6FNIJt4iHvMtn1AG95'], //97,,
    serverIPAddress: '35.222.170.66',
    shippoMarketplaceAppId: '667be96e1a97efaa35eeee7d',
    shipstationMarketplaceAppId: '67d7e11c528c229a429a8e99',
    stripeKey: override ? 'pk_live_MtxwO3obi7pfD7UZlGkfR2yj' : 'pk_test_WvH5LGch2F7bqyIJ6gVMu3iE',
    termsOfServiceThrottle: 3,
    tosVersion: '19/08/2024',
    whatsappMetaAppId: 1625143561229486,
    whatsappMetaAppVersion: 'v23.0',
    whitelabelIPAddress: override ? '34.70.111.192' : '34.66.216.217',
    workflowServiceURL: 'https://staging.backend.leadconnectorhq.com/workflow',
    freshchat: {
      token: 'f89e9094-c42d-425f-8e0b-82dd575529c8',
      host: 'https://highlevel-team.freshchat.com',
      widgetUuid: '9c8c99e5-f140-46f5-a08e-2bc6a85f8389',
      successWidgetUUID: '03d8e556-9687-4f2b-a61b-853a686f8eda'
    },
    agentStudioAgencyIds: ['gjL2sFNXJfJYa3d2OYSN'],
    agentStudioSubAccountIds: ['vEoIigWSAw1BQA9DEchD'],
  },
  staging: {
    affiliatePolicyVersion: '03/02/2021',
    calendarRecurringEventsEnabled: ['5DP4iH6HLkQsiKESj6rh', 'z15tg6TRo3BPFPhquVuz'],
    companyIdForManagingTemplates: 'eejDKnO8OMdu5q4F7rMB',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    depreciatedFeatureDate: '2021-09-21',
    fcmPublicKey: 'BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4',
    fcmSenderId: '85350210461',
    firebase: {
      apiKey: 'AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo',
      authDomain: 'highlevel-staging.firebaseapp.com',
      databaseURL: 'https://highlevel-staging.firebaseio.com',
      projectId: 'highlevel-staging',
      storageBucket: 'highlevel-staging.appspot.com',
      messagingSenderId: '85350210461',
      appId: '1:85350210461:web:d3728d34bf8bd6b5',
    },
    funnelShare: 'https://affiliate-dot-highlevel-staging.appspot.com',
    gdprSignDocument: 'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    genericElizaId: 'events-search-enhv',
    googleAuthId: '85350210461-eu3b772ek6gqmlpeim86m62ab9i9u5pc.apps.googleusercontent.com',
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    hipaaComplianceServiceId: 'tecJjL67Ol5kwLItrBwe',
    internalAgencyForLevelUp: ['5DP4iH6HLkQsiKESj6rh', 'aM2Z760DXgoa6AIEZx8N'],
    locationIdForTemplateLibrary: 'f8xXtCLtJndXyDchiomd',
    mode: 'staging',
    newCalendarSettingsEnabled: ['5DP4iH6HLkQsiKESj6rh'],
    printfulMarketplaceAppId: '660521e9a3fdabb92ce522a8',
    privacyPolicyVersion: '19/08/2024',
    seasonOfAIEnabledAgency:[
      '5DP4iH6HLkQsiKESj6rh',
      'KxPPrN1TUQdti5UBmPxR',
      '0iYoWYlmHoUBP2ZW6R7P',
      '8BSZPFT2PdzbeF4rIGX3',
      'zycCcd3QGdr5dZ739G6b', //trial
      '10nCS4icS5y5G5j5lCTB', //297
      '2DqbmJKMiiOAveUdzs12', //297
      '3x5QvX4vaasaecjwCKEP',
      'Su6FNIJt4iHvMtn1AG95'],
    serverIPAddress: '35.222.170.66',
    shippoMarketplaceAppId: '667be96e1a97efaa35eeee7d',
    shipstationMarketplaceAppId: '67d7e11c528c229a429a8e99',
    stripeKey: 'pk_test_WvH5LGch2F7bqyIJ6gVMu3iE',
    termsOfServiceThrottle: 3,
    tosVersion: '19/08/2024',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v23.0',
    whitelabelIPAddress: '34.66.216.217',
    workflowServiceURL: 'https://staging.backend.leadconnectorhq.com/workflow',
    freshchat: {
      token: 'f89e9094-c42d-425f-8e0b-82dd575529c8',
      host: 'https://highlevel-team.freshchat.com',
      widgetUuid: '9c8c99e5-f140-46f5-a08e-2bc6a85f8389',
      successWidgetUUID: '03d8e556-9687-4f2b-a61b-853a686f8eda'
    },
    agentStudioAgencyIds: ['gjL2sFNXJfJYa3d2OYSN'],
    agentStudioSubAccountIds: ['vEoIigWSAw1BQA9DEchD'],
  },
  interop: {
    affiliatePolicyVersion: '03/02/2021',
    calendarRecurringEventsEnabled: ['5DP4iH6HLkQsiKESj6rh', 'z15tg6TRo3BPFPhquVuz'],
    companyIdForManagingTemplates: 'eejDKnO8OMdu5q4F7rMB',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    depreciatedFeatureDate: '2021-09-21',
    fcmPublicKey: 'BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4',
    fcmSenderId: '85350210461',
    firebase: {
      apiKey: 'AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo',
      authDomain: 'highlevel-staging.firebaseapp.com',
      databaseURL: 'https://highlevel-staging.firebaseio.com',
      projectId: 'highlevel-staging',
      storageBucket: 'highlevel-staging.appspot.com',
      messagingSenderId: '85350210461',
      appId: '1:85350210461:web:d3728d34bf8bd6b5',
    },
    funnelShare: 'https://affiliate-dot-highlevel-staging.appspot.com',
    gdprSignDocument: 'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    genericElizaId: 'events-search-enhv',
    googleAuthId: '85350210461-eu3b772ek6gqmlpeim86m62ab9i9u5pc.apps.googleusercontent.com',
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    hipaaComplianceServiceId: 'tecJjL67Ol5kwLItrBwe',
    internalAgencyForLevelUp: ['5DP4iH6HLkQsiKESj6rh', 'aM2Z760DXgoa6AIEZx8N'],
    locationIdForTemplateLibrary: 'f8xXtCLtJndXyDchiomd',
    mode: 'staging',
    newCalendarSettingsEnabled: ['5DP4iH6HLkQsiKESj6rh'],
    printfulMarketplaceAppId: '660521e9a3fdabb92ce522a8',
    privacyPolicyVersion: '19/08/2024',
    seasonOfAIEnabledAgency:[
      '5DP4iH6HLkQsiKESj6rh',
      'KxPPrN1TUQdti5UBmPxR',
      '0iYoWYlmHoUBP2ZW6R7P',
      '8BSZPFT2PdzbeF4rIGX3',
      'zycCcd3QGdr5dZ739G6b', //trial
      '10nCS4icS5y5G5j5lCTB', //297
      '2DqbmJKMiiOAveUdzs12', //297
      '3x5QvX4vaasaecjwCKEP',
      'Su6FNIJt4iHvMtn1AG95'],
    serverIPAddress: '35.222.170.66',
    shippoMarketplaceAppId: '667be96e1a97efaa35eeee7d',
    shipstationMarketplaceAppId: '67d7e11c528c229a429a8e99',
    stripeKey: 'pk_test_WvH5LGch2F7bqyIJ6gVMu3iE',
    termsOfServiceThrottle: 3,
    tosVersion: '19/08/2024',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v23.0',
    whitelabelIPAddress: '34.66.216.217',
    workflowServiceURL: 'https://interop.backend.leadconnectorhq.com/workflow',
    freshchat: {
      token: 'f89e9094-c42d-425f-8e0b-82dd575529c8',
      host: 'https://highlevel-team.freshchat.com',
      widgetUuid: '9c8c99e5-f140-46f5-a08e-2bc6a85f8389',
      successWidgetUUID: '03d8e556-9687-4f2b-a61b-853a686f8eda'
    },
    agentStudioAgencyIds: ['gjL2sFNXJfJYa3d2OYSN'],
    agentStudioSubAccountIds: ['vEoIigWSAw1BQA9DEchD'],
  },
  beta: {
    affiliatePolicyVersion: '03/02/2021',
    calendarRecurringEventsEnabled: ['YuTUZlUtrwBtvmgByZDW'],
    companyIdForManagingTemplates: 'pfpm9iFi4k5yvjnstXWU',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    depreciatedFeatureDate: '2021-10-21',
    fcmPublicKey: 'BAVB9sZxhteplpxkSQXvCF57NEXzFZbC3aO6sFxQGH5vujYLN12R6HxD52REe_xMotrXqAIeroKrQlAAgJH3hMc',
    fcmSenderId: '439472444885',
    firebase: {
      apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
      authDomain: 'highlevel-backend.firebaseapp.com',
      databaseURL: 'https://highlevel-backend.firebaseio.com',
      projectId: 'highlevel-backend',
      storageBucket: 'highlevel-backend.appspot.com',
      messagingSenderId: '439472444885',
      appId: '1:439472444885:android:c48022009a58ffc7',
    },
    funnelShare: 'https://affiliates.gohighlevel.com',
    gdprSignDocument: 'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    genericElizaId: 'snehal-new-agent-kqqa',
    googleAuthId: '662044898224-7rdo6sjo4hf8qief3lpqb24bh9rvut5t.apps.googleusercontent.com',
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    hipaaComplianceServiceId: '1kMapL1iT8LNZhXsv6IC',
    internalAgencyForLevelUp: ['YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'],
    locationIdForTemplateLibrary: 'BDB6ZHTCnEejjv30r16r',
    mode: 'production',
    newCalendarSettingsEnabled: ['YuTUZlUtrwBtvmgByZDW'],
    printfulMarketplaceAppId: '66446db8c205c11d4067d82b',
    privacyPolicyVersion: '19/08/2024',
    seasonOfAIEnabledAgency: ['YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'],
    serverIPAddress: '34.68.234.4',
    shippoMarketplaceAppId: '66c46f40a8f668ddcdce87b3',
    shipstationMarketplaceAppId: '686660f001b17a8668cea06a',
    stripeKey: 'pk_live_MtxwO3obi7pfD7UZlGkfR2yj',
    termsOfServiceThrottle: 100,
    tosVersion: '19/08/2024',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v23.0',
    whitelabelIPAddress: '34.70.111.192',
    workflowServiceURL: 'https://backend.leadconnectorhq.com/workflow',
    freshchat: {
      token: 'f89e9094-c42d-425f-8e0b-82dd575529c8',
      host: 'https://highlevel-team.freshchat.com'
    },
    agentStudioAgencyIds: ['E4s8LSG3BVIkm6xmGPUh', 'YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'],
    agentStudioSubAccountIds: ['8RePOy9L37I8V2h5j4RW', '2HPKoAi2uwO71yfM5xvP', 'e9SEQ0yUw2IN49Tyd3ED', 'ov9YQ7INpTdiLggLSGFg', 'ahbFlpKU4GvKxq5sNGrb', 'kfATa3CBXItiUz8YvMeC', 'mI1DHnIrzjAltyk0sgv2', 'c3cmUrbBhdgs54adfIYP', 'Sr99nTAsuyCabfQCL1JQ', 'mo4vucpmfxNkPcaP2eba', 'OTzVLJMI3aHvXJhuMe5c', 's7Emnk5puo42JzVw7o32', 'c9joV4p9YFf86TIFp8ll', 'q0F6ceFXwWu8TQhnvU2R', 'XkxChwPSSg7Vcm64EW17', 'LCp6naDXdqdF0tLGOlOB', 'As4d7UDXdRhJvVyeJIOH', 'VUc1GSivMC6X6ODs8NRd','5fYg0QBR6S2Abm6sMjpY', 'n26oX9nNg6MdIrAlZQDg', 'dsdugwoA8Q8SSc1BEM3V', 'clbg3hVAvf7PDYPGWJqt', 'ho9nn6HUbhFw30p8AB37', 'UJAYVGW1mRUMYhO5BCgG', 'zH3QoCqX1ntegi3OEHOg', 'TnvO2Sk5wddwnTLlhgaz'],
  },
  production: {
    affiliatePolicyVersion: '03/02/2021',
    calendarRecurringEventsEnabled: ['YuTUZlUtrwBtvmgByZDW'],
    companyIdForManagingTemplates: 'pfpm9iFi4k5yvjnstXWU',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    depreciatedFeatureDate: '2021-10-21',
    fcmPublicKey: 'BAVB9sZxhteplpxkSQXvCF57NEXzFZbC3aO6sFxQGH5vujYLN12R6HxD52REe_xMotrXqAIeroKrQlAAgJH3hMc',
    fcmSenderId: '439472444885',
    firebase: {
      apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
      authDomain: 'highlevel-backend.firebaseapp.com',
      databaseURL: 'https://highlevel-backend.firebaseio.com',
      projectId: 'highlevel-backend',
      storageBucket: 'highlevel-backend.appspot.com',
      messagingSenderId: '439472444885',
      appId: '1:439472444885:android:c48022009a58ffc7',
    },
    funnelShare: 'https://affiliates.gohighlevel.com',
    gdprSignDocument: 'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    genericElizaId: 'snehal-new-agent-kqqa',
    googleAnalyticId: 'UA-115177999-2',
    googleAuthId: '662044898224-7rdo6sjo4hf8qief3lpqb24bh9rvut5t.apps.googleusercontent.com',
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    hipaaComplianceServiceId: '1kMapL1iT8LNZhXsv6IC',
    internalAgencyForLevelUp: ['YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'],
    locationIdForTemplateLibrary: 'BDB6ZHTCnEejjv30r16r',
    mode: 'production',
    newCalendarSettingsEnabled: ['YuTUZlUtrwBtvmgByZDW'],
    printfulMarketplaceAppId: '66446db8c205c11d4067d82b',
    privacyPolicyVersion: '19/08/2024',
    seasonOfAIEnabledAgency: ['YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'],
    serverIPAddress: '34.68.234.4',
    shippoMarketplaceAppId: '66c46f40a8f668ddcdce87b3',
    shipstationMarketplaceAppId: '686660f001b17a8668cea06a',
    stripeKey: 'pk_live_MtxwO3obi7pfD7UZlGkfR2yj',
    termsOfServiceThrottle: 100,
    tosVersion: '19/08/2024',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v23.0',
    whitelabelIPAddress: '34.70.111.192',
    workflowServiceURL: 'https://backend.leadconnectorhq.com/workflow',
    freshchat: {
      token: 'f89e9094-c42d-425f-8e0b-82dd575529c8',
      host: 'https://highlevel-team.freshchat.com',
      successWidgetUUID: '03d8e556-9687-4f2b-a61b-853a686f8eda'
    },
    agentStudioAgencyIds: ['E4s8LSG3BVIkm6xmGPUh', 'YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'],
    agentStudioSubAccountIds: ['8RePOy9L37I8V2h5j4RW', '2HPKoAi2uwO71yfM5xvP', 'e9SEQ0yUw2IN49Tyd3ED', 'ov9YQ7INpTdiLggLSGFg', 'ahbFlpKU4GvKxq5sNGrb', 'kfATa3CBXItiUz8YvMeC', 'mI1DHnIrzjAltyk0sgv2', 'c3cmUrbBhdgs54adfIYP', 'Sr99nTAsuyCabfQCL1JQ', 'mo4vucpmfxNkPcaP2eba', 'OTzVLJMI3aHvXJhuMe5c', 's7Emnk5puo42JzVw7o32', 'c9joV4p9YFf86TIFp8ll', 'q0F6ceFXwWu8TQhnvU2R', 'XkxChwPSSg7Vcm64EW17', 'LCp6naDXdqdF0tLGOlOB', 'As4d7UDXdRhJvVyeJIOH', 'VUc1GSivMC6X6ODs8NRd','5fYg0QBR6S2Abm6sMjpY', 'n26oX9nNg6MdIrAlZQDg', 'dsdugwoA8Q8SSc1BEM3V', 'clbg3hVAvf7PDYPGWJqt', 'ho9nn6HUbhFw30p8AB37', 'UJAYVGW1mRUMYhO5BCgG', 'zH3QoCqX1ntegi3OEHOg', 'TnvO2Sk5wddwnTLlhgaz'],
  },
}

const constants = config[ override ? 'production' : process.env.NODE_ENV as keyof typeof config]

if (process.env.NODE_ENV === 'development' && !override) {
}

export default constants
